import React, { useCallback, useContext, useMemo } from 'react';
import { debounce } from 'underscore';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Combobox, Option, Field, makeStyles, tokens, mergeClasses } from '@fluentui/react-components';
import { useComboboxFilter } from '@fluentui/react-combobox';
import { COUNTRY_STRINGS } from '@bingads-webui-campaign/ads-globalization';
import { useBulkLocationsSearchContext } from './bulk-locations-search-provider';

const useStyles = makeStyles({
  select: {
    marginBottom: tokens.spacingVerticalMNudge,
    width: '100%',
  },
});

const CountrySelect = () => {
  const i18n = useContext(I18nContext);
  const classes = useStyles();
  const [query, setQuery] = React.useState('');
  const { handleCountrySelect } = useBulkLocationsSearchContext();

  const sortedOptions = useMemo(() => Object.entries(COUNTRY_STRINGS).map(([key, value]) => [key, i18n.getString(value)])
    .sort(([, valueA], [, valueB]) => valueA.localeCompare(valueB)), [i18n]);

  const debouncedSetQuery = useCallback(debounce(value => setQuery(value), 10), []);

  const onCountrySelect = useCallback((e, data) => {
    setQuery(data.optionText ?? '');
    handleCountrySelect(e, data);
  }, [handleCountrySelect]);

  const children = useComboboxFilter(query, sortedOptions, {
    noOptionsMessage: i18n.getString(_TL_('No countries/regions match your search.')),
    optionToText: ([, value]) => value,
    renderOption: ([key, value]) => (
      <Option key={key} value={key}>
        {value}
      </Option>
    ),
  });

  return (
    <Field label={i18n.getString(_TL_('Country or region (optional)'))}>
      <Combobox
        onOptionSelect={onCountrySelect}
        onChange={e => debouncedSetQuery(e.target.value)}
        value={query}
        className={mergeClasses(classes.select, 'bulk-locations-country-select')}
        placeholder={i18n.getString(_TL_('Choose the country/region for locations added below'))}
      >
        {children}
      </Combobox>
    </Field>
  );
};

export default CountrySelect;
